import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=9660ff58&scoped=true"
import script from "./Files.vue?vue&type=script&lang=js"
export * from "./Files.vue?vue&type=script&lang=js"
import style0 from "./Files.vue?vue&type=style&index=0&id=9660ff58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9660ff58",
  null
  
)

export default component.exports